/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-11-08, 11:53:38
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2017-12-04, 14:51:30
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

export const FILL_NOTIFY_STATUSES_DEFINITION = 'FILL_NOTIFY_STATUSES_DEFINITION';
export const SET_CONNECTIONS_DOWNLOAD_PARAMS = 'SET_CONNECTIONS_DOWNLOAD_PARAMS';
export const FILL_CONNECTIONS_LIST = 'FILL_CONNECTIONS_LIST';
export const CLEAR_CONNECTION_LIST = 'CLEAR_CONNECTIONS_LIST';
export const INCREASE_NOTES_COUNT_IN_CONNECTION_RECORD = 'INCREASE_NOTES_COUNT_IN_CONNECTION_RECORD';
